import React, { useEffect, useState } from 'react';
import Bread from 'modules/layoutModule/components/Bread/Bread';
import { HomeOutlined, EditOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { Breadcrumb, Pagination, ConfigProvider, BackTop } from 'antd';
import { Table, Space, Tooltip, Button } from 'antd';
import {
  getNewsCategoriesRequest,
  removeSpecificNewsCategoryRequest,
} from 'modules/newsModule/requests/newsRequests';
import plPL from 'antd/lib/locale/pl_PL';
import TableDateRow from 'modules/layoutModule/components/TableDateRow/TableDateRow';
import TableDataRowTypes from 'modules/layoutModule/enums/TableDataRowTypes';
import TableDeleteRow from 'modules/layoutModule/components/TableDeleteRow/TableDeleteRow';

export interface NewsCategoriesTableTypes {
  id: number;
  name: string;
  isActive: boolean;
  deleteAvailable: boolean;
}

const News = (): JSX.Element => {
  const [tableData, setTableData] = useState<NewsCategoriesTableTypes[]>([]);
  const [loading, toggleLoading] = useState<boolean>(true);

  const confirmDelete = (id: number) => {
    removeSpecificNewsCategoryRequest(id).then((response) => {
      if (response) {
        downloadCategories();
      }
    });
  };

  const downloadCategories = () =>
    getNewsCategoriesRequest().then((response) => {
      if (response) {
        const { data } = response;
        setTableData(data);
        toggleLoading(false);
      } else {
        toggleLoading(false);
      }
    });

  useEffect(() => {
    if (tableData.length === 0) {
      downloadCategories();
    }
  }, [tableData]);

  const columns = [
    {
      title: 'Nazwa',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: { name: string }, b: { name: string }) =>
        a.name.localeCompare(b.name),
    },
    {
      title: 'Kolejność',
      dataIndex: 'sortOrder',
      key: 'sortOrder',
      width: 100,
      sorter: (a: any, b: any) => a.sortOrder - b.sortOrder,
      render: (text: string, record: any) => (
        <TableDateRow record={record} field={TableDataRowTypes.SORT} />
      ),
    },
    {
      title: 'Aktywna',
      dataIndex: 'isActive',
      key: 'isActive',
      width: '150px',
      render: (text: string, record: any) => (
        <TableDateRow record={record} field={TableDataRowTypes.IS_ACTIVE} />
      ),
      sorter: (a: { isActive: number }, b: { isActive: number }) =>
        a.isActive - b.isActive,
      filters: [
        {
          text: 'TAK',
          value: 'isActive',
        },
        {
          text: 'NIE',
          value: 'isNotActive',
        },
      ],
      onFilter: (value: string, record: { isActive: boolean }) => {
        if (value === 'isActive') {
          return record.isActive;
        }
        return !record.isActive;
      },
    },
    {
      title: 'Akcje',
      dataIndex: 'operation',
      key: 'operation',
      width: 100,
      render: (_text: any, item: NewsCategoriesTableTypes) => (
        <Space
          size="middle"
          style={{ display: 'Flex', flexDirection: 'column' }}
        >
          <Tooltip title="Edytuj wpis">
            <Link to={`/news/categories/${item.id}`}>
              <Button type="primary" shape="circle" icon={<EditOutlined />} />
            </Link>
          </Tooltip>
          <TableDeleteRow
            deleteAvailable={item.deleteAvailable && !item.isActive}
            onConfirm={() => confirmDelete(item.id)}
          />
        </Space>
      ),
    },
  ];

  return (
    <>
      <Bread>
        <>
          <Breadcrumb.Item>
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>Aktualności</Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/news/categories">Kategorie</Link>
          </Breadcrumb.Item>
        </>
      </Bread>
      <ConfigProvider locale={plPL}>
        <Table
          // @ts-ignore
          columns={columns}
          dataSource={tableData}
          loading={loading}
        >
          <Pagination />
        </Table>
        <BackTop />
      </ConfigProvider>
    </>
  );
};

export default News;
